import React, { useState } from 'react';
import { X, Eye, EyeOff, ChevronDown } from 'lucide-react';
import './AddCourierModal.css';

export default function AddCourierModal({ isOpen, onClose, onAddSuccess, vehicles = [] }) {
  const [formData, setFormData] = useState({
    fullName: '',
    username: '',
    password: '',
    phone: '',
    plateNo: ''
  });
  const [showPassword, setShowPassword] = useState(false);
  const [vehicleSearch, setVehicleSearch] = useState('');
  const [vehicleDropdownOpen, setVehicleDropdownOpen] = useState(false);
  const [error, setError] = useState(null);

  if (!isOpen) return null;

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);

    if (!formData.fullName || !formData.username || !formData.password) {
      setError('All fields are required');
      return;
    }

    try {
      await onAddSuccess(formData);

      setFormData({
        fullName: '',
        username: '',
        password: '',
        phone: '',
        plateNo: ''
      });

      onClose();
    } catch (err) {
      setError(
          err.response?.data ||
          err.message ||
          'Failed to create courier account'
      );
    }
  };

  const togglePasswordVisibility = () => {
    setShowPassword(!showPassword);
  };

  return (
    <div className="modal-overlay">
      <div className="modal-content add-courier-modal">
        <div className="modal-header">
          <div className="modal-title-group">
            <h2>Create courier account</h2>
            <p className="modal-subtitle">Add a new courier to the fleet system</p>
          </div>
          <button className="modal-close" onClick={onClose} aria-label="Close modal">
            <X size={20} />
          </button>
        </div>

        {error && <div className="modal-error">{error}</div>}

        <form onSubmit={handleSubmit} className="modal-form">
          <div className="form-group">
            <label htmlFor="fullName">Courier full name</label>
            <input
              id="fullName"
              name="fullName"
              value={formData.fullName}
              onChange={handleChange}
              required
              placeholder="e.g. Ali Aliyev"
            />
          </div>
          <div className="form-group">
            <label htmlFor="username">Courier username</label>
            <input
              id="username"
              name="username"
              value={formData.username}
              onChange={handleChange}
              required
              placeholder="e.g. alialiyev"
            />
          </div>
          <div className="form-group">
            <label htmlFor="phone">Phone number</label>
            <input
              id="phone"
              name="phone"
              value={formData.phone}
              onChange={handleChange}
              placeholder="e.g. 501234567"
            />
          </div>
          <div className="form-group">
            <label>Vehicle Plate Number</label>
            <div style={{ position: 'relative' }}>
              <div
                  style={{ border: '1px solid #d1d5db', borderRadius: vehicleDropdownOpen ? '8px 8px 0 0' : '8px', padding: '10px 14px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', alignItems: 'center', background: '#fff' }}
                  onClick={() => setVehicleDropdownOpen(o => !o)}
              >
                {vehicleDropdownOpen ? (
                    <input
                        autoFocus
                        value={vehicleSearch}
                        onChange={e => setVehicleSearch(e.target.value)}
                        onClick={e => e.stopPropagation()}
                        placeholder="Search plate or model..."
                        style={{ border: 'none', outline: 'none', width: '100%' }}
                    />
                ) : (
                    <span style={{ color: formData.plateNo ? '#111827' : '#9ca3af' }}>
          {formData.plateNo || 'Select plate number...'}
        </span>
                )}
                <ChevronDown size={16} style={{ transition: '0.2s', transform: vehicleDropdownOpen ? 'rotate(180deg)' : 'none' }} />
              </div>
              {vehicleDropdownOpen && (
                  <div style={{ border: '1px solid #d1d5db', borderTop: 'none', borderRadius: '0 0 8px 8px', maxHeight: 180, overflowY: 'auto', background: '#fff', position: 'absolute', width: '100%', zIndex: 10 }}>
                    {vehicles
                        .filter(v => v.plateNo.toLowerCase().includes(vehicleSearch.toLowerCase()) || v.model.toLowerCase().includes(vehicleSearch.toLowerCase()))
                        .map(v => (
                            <div
                                key={v.plateNo}
                                onClick={() => { setFormData(p => ({ ...p, plateNo: v.plateNo })); setVehicleDropdownOpen(false); setVehicleSearch(''); }}
                                style={{ padding: '10px 14px', cursor: 'pointer', display: 'flex', justifyContent: 'space-between', background: formData.plateNo === v.plateNo ? '#eff6ff' : 'transparent' }}
                            >
                              <span style={{ fontWeight: 500 }}>{v.plateNo}</span>
                              <span style={{ color: '#6b7280', fontSize: 13 }}>{v.model}</span>
                            </div>
                        ))}
                  </div>
              )}
            </div>
          </div>
          <div className="form-group password-group">
            <label htmlFor="password">Temporary password</label>
            <div className="password-input-wrapper">
              <input
                id="password"
                type={showPassword ? "text" : "password"}
                name="password"
                value={formData.password}
                onChange={handleChange}
                required
                placeholder="Enter temporary password"
              />
              <button
                type="button"
                className="password-toggle-btn"
                onClick={togglePasswordVisibility}
                aria-label={showPassword ? "Hide password" : "Show password"}
              >
                {showPassword ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>

          <div className="modal-actions">
            <button type="submit" className="btn-submit create-courier-btn">
              Create courier
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
